import React, { Component } from "react";
import { Table, Thead, Tbody, Tr, Th, Td, Grid, GridItem, Box } from '@chakra-ui/react';

import "../../../../assets/css/order-grid.css";

export default class DetailOrderTable extends Component {

    constructor(props) {
        super(props);

        this.state = {
        };


    }

    componentDidMount() {

    }

    render() {
        return (
            <Box width="100%">
                {(this.props.selectedRow) &&
                <Grid templateColumns={'repeat(10, 1fr)'} bgColor={"white"} border={ '#b4bcc4 solid 1px'} borderRadius={'2px'} w="100%">
                    <GridItem className="order-header">Order</GridItem>
                    <GridItem className="order-header">PO</GridItem>
                    <GridItem className="order-header">Ship To</GridItem>
                    <GridItem className="order-header">ShipFrom</GridItem>
                    <GridItem className="order-header">Ship Date</GridItem>
                    <GridItem className="order-header">ETA</GridItem>
                    <GridItem className="order-header">Repost</GridItem>
                    <GridItem className="order-header">Mixed?</GridItem>
                    <GridItem className="order-header">Purchased?</GridItem>
                    <GridItem className="order-header">Last Message</GridItem>
                    <GridItem className="order-item">{this.props.selectedRow?.customerBatchId}</GridItem>
                    <GridItem className="order-item">{this.props.selectedRow?.retailerBatchId}</GridItem>
                    <GridItem className="order-item">{this.props.selectedRow?.shipTo}</GridItem>

                    <GridItem className="order-item">{this.props.selectedRow?.shipFrom}</GridItem>
                    <GridItem className="order-item">{this.props.selectedRow?.shipDateTimeLocal}</GridItem>
                    <GridItem className="order-item">{this.props.selectedRow?.etaDateTimeLocal}</GridItem>

                    <GridItem className="order-item">{(this.props.selectedRow?.repostInfo?.isRepost) ? "true" : "false"}</GridItem>
                    <GridItem className="order-item">{(this.props.selectedRow?.hasMixedLots) ? "true" : "false"}</GridItem>
                    <GridItem className="order-item">{(this.props.selectedRow?.hasPurchasedLots) ? "true" : "false"}</GridItem>

                    <GridItem className="order-item">{this.props.selectedRow?.lastMessage}</GridItem>
                </Grid>
                }
            </Box>
        )
    }



}